// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #000000;
  color: #888888;
  height: 100vh;
  overflow: hidden;
  font-size: 12px;
}

#app {
  height: 100vh;
  position: relative;
}

.screen {
  height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.hidden {
  display: none !important;
}

/* Settings Form Styles */
.settings-form {
  flex: 1;
  max-width: 400px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.setting-group {
  margin-bottom: 25px;
}

.setting-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #888888;
  font-size: 16px;
}

.setting-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #444444;
  border-radius: 8px;
  font-size: 16px;
  background-color: #222222;
  color: #cccccc;
  transition: border-color 0.3s;
}

.setting-group input:focus {
  outline: none;
  border-color: #1565C0; /* Darker blue */
}

.setting-group small {
  display: block;
  margin-top: 4px;
  color: #666666;
  font-size: 13px;
}

.calculated-values {
  margin-top: 30px;
  padding: 20px;
  background-color: #1a1a1a;
  border-radius: 8px;
  border-left: 4px solid #1565C0; /* Darker blue */
}

.calculated-values h3 {
  margin-bottom: 15px;
  color: #1565C0; /* Darker blue */
  font-size: 16px;
}

.calc-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.calc-row span:first-child {
  color: #888888;
}

.calc-row span:last-child {
  font-weight: 600;
  color: #1565C0; /* Darker blue */
}

/* Settings OK Button */
.settings-ok-button {
  position: absolute;
  bottom: 20px;
  left: 20px;
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: none;
  background-color: #2E7D32; /* Darker green */
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.settings-ok-button svg {
  width: 36px;
  height: 36px;
}

.settings-ok-button:hover {
  background-color: #1B5E20; /* Even darker green on hover */
}

.settings-ok-button:focus {
  outline: none;
}

/* Action Screen Styles */
#action-screen {
  font-size: 18px;
}

.top-left {
  position: absolute;
  top: 30px;
  left: 30px;
  font-size: 27px;
  font-weight: bold;
  color: #888888;
}

.top-right {
  position: absolute;
  top: 30px;
  right: 30px;
  font-size: 24px;
  color: #888888;
}

/* Breathing Container */
.breathing-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nostril-indicator {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #1565C0; /* Darker blue */
  transition: left 0.3s ease;
  top: 50%;
  transform: translateY(-50%);
}

.nostril-indicator.left {
  left: calc(50% - 120px);
}

.nostril-indicator.right {
  left: calc(50% + 90px);
}

.breathing-progress {
  width: 120px;
  height: 360px;
  border: 4px solid #444444;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  background-color: #222222;
  margin: 0 auto;
}

.progress-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0%;
  background: linear-gradient(to top, #1565C0, #1976D2); /* Darker blue gradient */
  transition-property: height;
  transition-timing-function: linear;
  transition-duration: 0.1s; /* Short transition for manual updates */
}

.hold-counter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  font-weight: bold;
  color: #333;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Button Styles */
.bottom-left {
  position: absolute;
  bottom: 30px;
  left: 30px;
}

.bottom-left button {
  display: block;
  margin-bottom: 15px;
}

.bottom-right {
  position: absolute;
  bottom: 30px;
  right: 30px;
}

.bottom-right button {
  display: block;
  margin-bottom: 15px;
}

.round-button {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: none;
  background-color: #1565C0; /* Darker blue */
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.round-button .icon-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.round-button svg {
  width: 36px;
  height: 36px;
}

.round-button.primary {
  background-color: #2E7D32; /* Darker green */
}

.round-button:hover {
  background-color: #0D47A1; /* Even darker blue on hover */
}

.round-button.primary:hover {
  background-color: #1B5E20; /* Even darker green on hover */
}

.round-button:focus {
  outline: none;
}

.adjustment-button {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: none;
  background-color: #2E7D32; /* Darker green */
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  outline: none;
}

.adjustment-button svg {
  width: 36px;
  height: 36px;
}

.adjustment-button:hover {
  background-color: #1B5E20; /* Even darker green on hover */
}

.adjustment-button:focus {
  outline: none;
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #888888;
  font-size: 24px;
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .screen {
      padding: 15px;
  }
  
  #action-screen {
      padding: 23px;
  }
  
  .settings-form {
      max-width: 100%;
  }
  
  .breathing-progress {
      width: 90px;
      height: 270px;
  }
  
  .hold-counter {
      font-size: 36px;
      width: 60px;
      height: 60px;
  }
  
  .nostril-indicator.left {
      left: calc(50% - 90px);
  }
  
  .nostril-indicator.right {
      left: calc(50% + 60px);
  }
  
  .round-button, .adjustment-button, .settings-ok-button {
      width: 68px;
      height: 68px;
  }
  
  .round-button svg, .adjustment-button svg, .settings-ok-button svg {
      width: 30px;
      height: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,gBAAgB;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B,EAAE,gBAAgB;AAClD;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,gBAAgB;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;AAClC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,0BAA0B;EAC1B,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,UAAU;EACV,qDAAqD,EAAE,yBAAyB;EAChF,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;MACI,aAAa;EACjB;;EAEA;MACI,aAAa;EACjB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;MACX,aAAa;EACjB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,sBAAsB;EAC1B;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background-color: #000000;\n  color: #888888;\n  height: 100vh;\n  overflow: hidden;\n  font-size: 12px;\n}\n\n#app {\n  height: 100vh;\n  position: relative;\n}\n\n.screen {\n  height: 100vh;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.hidden {\n  display: none !important;\n}\n\n/* Settings Form Styles */\n.settings-form {\n  flex: 1;\n  max-width: 400px;\n  margin: 0 auto;\n  padding-bottom: 80px;\n}\n\n.setting-group {\n  margin-bottom: 25px;\n}\n\n.setting-group label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #888888;\n  font-size: 16px;\n}\n\n.setting-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #444444;\n  border-radius: 8px;\n  font-size: 16px;\n  background-color: #222222;\n  color: #cccccc;\n  transition: border-color 0.3s;\n}\n\n.setting-group input:focus {\n  outline: none;\n  border-color: #1565C0; /* Darker blue */\n}\n\n.setting-group small {\n  display: block;\n  margin-top: 4px;\n  color: #666666;\n  font-size: 13px;\n}\n\n.calculated-values {\n  margin-top: 30px;\n  padding: 20px;\n  background-color: #1a1a1a;\n  border-radius: 8px;\n  border-left: 4px solid #1565C0; /* Darker blue */\n}\n\n.calculated-values h3 {\n  margin-bottom: 15px;\n  color: #1565C0; /* Darker blue */\n  font-size: 16px;\n}\n\n.calc-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.calc-row span:first-child {\n  color: #888888;\n}\n\n.calc-row span:last-child {\n  font-weight: 600;\n  color: #1565C0; /* Darker blue */\n}\n\n/* Settings OK Button */\n.settings-ok-button {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  border: none;\n  background-color: #2E7D32; /* Darker green */\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.3s;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n}\n\n.settings-ok-button svg {\n  width: 36px;\n  height: 36px;\n}\n\n.settings-ok-button:hover {\n  background-color: #1B5E20; /* Even darker green on hover */\n}\n\n.settings-ok-button:focus {\n  outline: none;\n}\n\n/* Action Screen Styles */\n#action-screen {\n  font-size: 18px;\n}\n\n.top-left {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  font-size: 27px;\n  font-weight: bold;\n  color: #888888;\n}\n\n.top-right {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n  font-size: 24px;\n  color: #888888;\n}\n\n/* Breathing Container */\n.breathing-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.nostril-indicator {\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: #1565C0; /* Darker blue */\n  transition: left 0.3s ease;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.nostril-indicator.left {\n  left: calc(50% - 120px);\n}\n\n.nostril-indicator.right {\n  left: calc(50% + 90px);\n}\n\n.breathing-progress {\n  width: 120px;\n  height: 360px;\n  border: 4px solid #444444;\n  border-radius: 12px;\n  position: relative;\n  overflow: hidden;\n  background-color: #222222;\n  margin: 0 auto;\n}\n\n.progress-fill {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 0%;\n  background: linear-gradient(to top, #1565C0, #1976D2); /* Darker blue gradient */\n  transition-property: height;\n  transition-timing-function: linear;\n  transition-duration: 0.1s; /* Short transition for manual updates */\n}\n\n.hold-counter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 48px;\n  font-weight: bold;\n  color: #333;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  width: 80px;\n  height: 80px;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n}\n\n/* Button Styles */\n.bottom-left {\n  position: absolute;\n  bottom: 30px;\n  left: 30px;\n}\n\n.bottom-left button {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.bottom-right {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n}\n\n.bottom-right button {\n  display: block;\n  margin-bottom: 15px;\n}\n\n.round-button {\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  border: none;\n  background-color: #1565C0; /* Darker blue */\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n}\n\n.round-button .icon-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.round-button svg {\n  width: 36px;\n  height: 36px;\n}\n\n.round-button.primary {\n  background-color: #2E7D32; /* Darker green */\n}\n\n.round-button:hover {\n  background-color: #0D47A1; /* Even darker blue on hover */\n}\n\n.round-button.primary:hover {\n  background-color: #1B5E20; /* Even darker green on hover */\n}\n\n.round-button:focus {\n  outline: none;\n}\n\n.adjustment-button {\n  width: 75px;\n  height: 75px;\n  border-radius: 50%;\n  border: none;\n  background-color: #2E7D32; /* Darker green */\n  color: white;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n}\n\n.adjustment-button svg {\n  width: 36px;\n  height: 36px;\n}\n\n.adjustment-button:hover {\n  background-color: #1B5E20; /* Even darker green on hover */\n}\n\n.adjustment-button:focus {\n  outline: none;\n}\n\nh1 {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #888888;\n  font-size: 24px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 480px) {\n  .screen {\n      padding: 15px;\n  }\n  \n  #action-screen {\n      padding: 23px;\n  }\n  \n  .settings-form {\n      max-width: 100%;\n  }\n  \n  .breathing-progress {\n      width: 90px;\n      height: 270px;\n  }\n  \n  .hold-counter {\n      font-size: 36px;\n      width: 60px;\n      height: 60px;\n  }\n  \n  .nostril-indicator.left {\n      left: calc(50% - 90px);\n  }\n  \n  .nostril-indicator.right {\n      left: calc(50% + 60px);\n  }\n  \n  .round-button, .adjustment-button, .settings-ok-button {\n      width: 68px;\n      height: 68px;\n  }\n  \n  .round-button svg, .adjustment-button svg, .settings-ok-button svg {\n      width: 30px;\n      height: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
